/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'copy': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M80.359 12H38.421a7.64 7.64 0 0 0-7.64 7.64v11.142H19.638A7.64 7.64 0 0 0 12 38.41v42a7.641 7.641 0 0 0 7.64 7.59h42a7.64 7.64 0 0 0 7.63-7.64V69.219h11.09a7.637 7.637 0 0 0 5.402-2.239 7.63 7.63 0 0 0 2.238-5.402V19.64a7.637 7.637 0 0 0-2.238-5.402 7.637 7.637 0 0 0-5.403-2.239zM65.218 67.16V80.359A3.637 3.637 0 0 1 61.589 84h-42A3.639 3.639 0 0 1 16 80.36v-42a3.64 3.64 0 0 1 3.64-3.629h42a3.64 3.64 0 0 1 3.63 3.63zm18.781-5.582a3.64 3.64 0 0 1-3.64 3.64H69.216V38.41a7.637 7.637 0 0 0-7.629-7.63H34.78V19.64A3.64 3.64 0 0 1 38.42 16h41.938a3.64 3.64 0 0 1 3.64 3.64z"/>'
  }
})
